import { ensureArrayIsNotEmpty } from "../../../../../Common/TypingUtils";
import { DataDeclarationHelper } from "../DataDeclaration/DataDeclarationHelper";
import {
    AbsoluteModelPath,
    AbsoluteResolvedModelPath,
    createAbsoluteFromMask,
    PathTokens,
} from "../../../../../Common/ModelPath/ModelPath";
import { BindingPath } from "../CoreTypes";
import { buildIterationSequence } from "../../../../../Common/ModelPath/BuildIterationSequence";
import { IterUtils } from "../../../../../Common/IterableUtils";
import { IFormReadonlyModelAccessor } from "../../Form/IFormModelAccessor";
import { InvalidProgramStateError } from "../../../../../Common/Errors";

export class MaskResolver {
    public static resolveMask(model: IFormReadonlyModelAccessor, mask: BindingPath): BindingPath[] {
        const path = createAbsoluteFromMask(mask, PathTokens.each);
        return Iterator.from(this.resolvePath(model, path))
            .map(x => x.toLegacyPath())
            .toArray();
    }

    public static getPathsByPrefix(
        dataDeclarationHelper: DataDeclarationHelper,
        model: IFormReadonlyModelAccessor,
        nodePathPrefix: AbsoluteModelPath
    ): Iterable<AbsoluteResolvedModelPath> {
        return Iterator.from(dataDeclarationHelper.getMasksByPrefix(nodePathPrefix)).flatMap(m =>
            MaskResolver.resolvePath(model, m)
        );
    }

    public static *resolvePath(
        model: IFormReadonlyModelAccessor,
        path: AbsoluteModelPath
    ): Iterable<AbsoluteResolvedModelPath> {
        if (path.isResolved()) {
            yield path;
        } else {
            const iterationSequence = buildIterationSequence(path);
            ensureArrayIsNotEmpty(iterationSequence);
            const { iterable, suffix } = IterUtils.first(iterationSequence);
            if (!iterable.isResolved()) {
                throw new InvalidProgramStateError();
            }
            const children = model.getChildren(iterable) ?? [];
            for (const childInstance of children) {
                yield* this.resolvePath(model, iterable.joinWith(childInstance, suffix));
            }
        }
    }
}
